// extracted by mini-css-extract-plugin
export var btnLayouts = "PagesLayout-module--btnLayouts--3640e";
export var clockCardStyle = "PagesLayout-module--clockCardStyle--4ce47";
export var codeStyle = "PagesLayout-module--codeStyle--c649c";
export var copyBlockStyle = "PagesLayout-module--copyBlockStyle--e3067";
export var formattedDateDisplayStyle = "PagesLayout-module--formattedDateDisplayStyle--4ad4d";
export var hamburgContainer = "PagesLayout-module--hamburgContainer--0bcbd";
export var homeCardLayout = "PagesLayout-module--homeCardLayout--5c18d";
export var inputLayouts = "PagesLayout-module--inputLayouts--702a4";
export var inputLayoutsHR = "PagesLayout-module--inputLayoutsHR--d3dc6";
export var inputLayoutsSelect = "PagesLayout-module--inputLayoutsSelect--df37f";
export var mainLayout = "PagesLayout-module--mainLayout--7806a";
export var quickLinksContainer = "PagesLayout-module--quickLinksContainer--9fd9f";
export var selectLayoutsForHrs = "PagesLayout-module--selectLayoutsForHrs--46cc1";
export var selectLayoutsHR = "PagesLayout-module--selectLayoutsHR--6baa7";
export var sideBarDrawerView = "PagesLayout-module--sideBarDrawerView--464a8";
export var sideBarView = "PagesLayout-module--sideBarView--deef2";
export var startAndEndDatesBtnLayout = "PagesLayout-module--startAndEndDatesBtnLayout--44e2d";
export var timerContainer = "PagesLayout-module--timerContainer--4286a";
export var timestampDisplayStyle = "PagesLayout-module--timestampDisplayStyle--6365e";
export var timestampToHumanReadableConverterContainer = "PagesLayout-module--timestampToHumanReadableConverterContainer--4490a";